import { Component, Input } from '@angular/core'
import { SafePipe } from '@app/shared/pipe/safe.pipe'
import { HeaderStyleService } from '@app/shared/services/header-style.service'
import { EnvService } from '@envs/env-service'
import { Router } from '@angular/router'
import { AuthService } from '@core/service/auth.service'

@Component({
  selector: 'app-deliverable-builder',
  templateUrl: './deliverable-builder.component.html',
  styleUrls: ['./deliverable-builder.component.scss'],
  providers: [SafePipe],
})
export class DeliverableBuilderComponent {
  @Input() id!: number
  @Input() deliverableId!: number
  @Input() changeRequestId?: number
  @Input() editLibDelEntryId!: number
  constructor(
    private headerStyleService: HeaderStyleService,
    private envService: EnvService,
    private router: Router,
    private authService: AuthService
  ) {
    window.addEventListener('message', (event) => {
      if (event.data.action === 'goToScope') {
        const url = this.changeRequestId
          ? `/scopes/scope-overview/${this.id}/change-request/${this.changeRequestId}`
          : `/scopes/scope-overview/${this.id}`
        this.router.navigateByUrl(url, { state: { skipWaitForLoad: true } })
      }
    })
  }

  public get baseJsUrl(): string {
    const crPath = this.changeRequestId ? `/change-request/${this.changeRequestId}` : ''
    return `${this.envService.baseJsUrl}/scope-overview/${this.id}${crPath}/deliverable/${this.deliverableId}?editLibDelEntryId=${this.editLibDelEntryId}&childCompany=${this.authService.loggedInUser?.company.id}`
  }
}
